import { useEffect, type FC } from 'react';

import { Chat } from '@pp/core/src/components/chat/chat/Chat';
import { MessagesWrapperConnected } from '@pp/core/src/components/chat/chat/messages/messagesWrapper/MessagesWrapperConnected';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useChatSlice } from '@pp/core/src/store/slices/chat/selectors';
import { chatActions } from '@pp/core/src/store/slices/chat/slice';
import { HeaderModal } from '@pp/core/src/store/slices/header/types';

import { ChatFooterConnected } from './footer/ChatFooterConnected';
import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';

export const CrashChatConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const gameChatMessages = useChatSlice.getGameChatMessages();
  const liveSupportChatMessages = useChatSlice.getLiveSupportChatMessages();
  const isSupport = useHighflyerGameStateSlice.getSelectedHeader() == HeaderModal.Support;

  useEffect(() => {
    if (isSupport) {
      // When player opens support chat, we mark notification as read
      dispatch(chatActions.setLiveSupportReadStatus(true));
    } else {
      // When player opens game chat, we mark it as a preferred chat
      // CoreSessionStorage.setIsChatClosed(false);
    }
  }, [dispatch, isSupport]);

  return (
    <Chat
      chatFooter={<ChatFooterConnected isGameChat={!isSupport} />}
      messagesWrapper={<MessagesWrapperConnected messages={isSupport ? liveSupportChatMessages : gameChatMessages} />}
    />
  );
};
